"use client";
import { useEffect } from "react";
import { dataLayerPush, pushDtsAppointmentStepEvent } from "@/lib/utils/dataLayerHelpers";
import { useAppContext } from "@/app/contextProviders/app-context";
import { usePathname, useSearchParams } from "next/navigation";

const PageView = () => {
	const { selectedOffice, deviceType, is404 } = useAppContext();
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const facilityCode = selectedOffice?.code || "";
	const facilityName = selectedOffice?.name || "";
	const facilityState = selectedOffice?.address?.stateCode || "";

	// Capture UTM parameters and store in cookie (client-side only, no re-render)
	useEffect(() => {
		const utmParams = searchParams.toString();
		if (utmParams && typeof document !== "undefined") {
			// Set cookie with 30-day expiration
			const maxAge = 30 * 24 * 60 * 60; // 30 days in seconds
			document.cookie = `marketing_source=${encodeURIComponent(utmParams)}; path=/; max-age=${maxAge}; SameSite=Lax`;
		}
	}, [searchParams]);

	// Track page views
	useEffect(() => {
		if (is404 || (facilityCode && facilityName)) {
			dataLayerPush({
				event: "virtual_page_view",
				brand: "Aspen Dental",
				site_section: "Marketing",
				is_404: is404,
				virtual_page_url: globalThis?.location?.href,
				virtual_page_title: globalThis?.document?.title,
				device_type: deviceType,
				website_selected_facility_id: facilityCode,
				website_selected_facility_name: facilityName,
				state: facilityState,
				page_origin_name: globalThis?.document?.title,
			});
		}
	}, [facilityCode, facilityState, deviceType, pathname, facilityName, is404]);

	useEffect(() => {
		if (
			!is404 &&
			(pathname === "/dts" || pathname.startsWith("/dts/")) &&
			facilityCode &&
			facilityName
		) {
			pushDtsAppointmentStepEvent({
				facilityCode,
				facilityName,
				state: facilityState,
			});
		}
	}, [facilityCode, facilityName, facilityState, pathname, is404]);

	return null;
};

export default PageView;
